import { render, staticRenderFns } from "./EmailStepDetail.vue?vue&type=template&id=568ca3fd&scoped=true"
import script from "./EmailStepDetail.vue?vue&type=script&lang=js"
export * from "./EmailStepDetail.vue?vue&type=script&lang=js"
import style0 from "./EmailStepDetail.vue?vue&type=style&index=0&id=568ca3fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568ca3fd",
  null
  
)

export default component.exports